import { Button } from "@/components/ui/Button";
import { userIsBuero, type CurrentUser } from "@/lib/auth";
import { DESKTOP_APP_SETUP_URL, isElectronRuntime } from "@/lib/electron";
import { classNames } from "@/lib/format";

type DesktopAppDownloadProps = {
  user: CurrentUser | null;
  /** `menu` = Profil-Dropdown; `settings` = Einstellungsseite. */
  variant?: "menu" | "settings";
  className?: string;
};

function startDesktopAppDownload() {
  // Cross-Origin: Browser lädt die .exe typischerweise direkt herunter.
  window.open(DESKTOP_APP_SETUP_URL, "_blank", "noopener,noreferrer");
}

/** Download der Desktop-App – nur für Büro, nicht innerhalb der Electron-App. */
export function DesktopAppDownload({
  user,
  variant = "menu",
  className,
}: DesktopAppDownloadProps) {
  if (!userIsBuero(user) || isElectronRuntime()) return null;

  if (variant === "settings") {
    return (
      <div
        className={classNames(
          "flex flex-col gap-3 px-5 py-4 sm:flex-row sm:items-center sm:justify-between",
          className,
        )}
      >
        <div className="min-w-0 space-y-1">
          <span className="block text-sm font-medium text-label">Ernsthaus Desktop-App</span>
          <span className="block text-sm text-label-secondary">
            Aktuellste Windows-Version herunterladen und installieren. Danach aktualisiert sich die
            App bei Bedarf selbst.
          </span>
        </div>
        <Button
          type="button"
          variant="secondary"
          size="sm"
          className="shrink-0"
          onClick={startDesktopAppDownload}
        >
          Herunterladen
        </Button>
      </div>
    );
  }

  return (
    <Button
      type="button"
      variant="secondary"
      size="sm"
      className={className}
      onClick={startDesktopAppDownload}
    >
      Desktop-App
    </Button>
  );
}
